import React, { Component } from 'react';

export default class ContactUs extends Component {
  render() {
    let resumeData = this.props.resumeData;
    return (
      <section id="contact">
        <div className="row section-head">
          <div className="twelve columns">
            <h1>Get In Touch</h1>
            <p className="lead">
              Feel free to contact me for opportunities, collaborations, or just to say hello!
            </p>
          </div>
        </div>

        <div className="row">
          <div className="twelve columns">
            <div className="contact-details-wrapper" style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexWrap: 'wrap',
              gap: '40px',
              marginTop: '30px'
            }}>
              {/* Email */}
              <div className="contact-item" style={{
                textAlign: 'center',
                padding: '30px',
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                borderRadius: '10px',
                minWidth: '280px',
                transition: 'transform 0.3s ease'
              }}>
                <i className="fa fa-envelope" style={{ fontSize: '48px', marginBottom: '15px', color: '#11ABB0' }}></i>
                <h4 style={{ marginBottom: '10px', color: '#EBEEEE' }}>Email</h4>
                <a href={`mailto:${resumeData.email}`} style={{ 
                  color: '#fff', 
                  fontSize: '16px',
                  textDecoration: 'none',
                  wordBreak: 'break-all'
                }}>
                  {resumeData.email}
                </a>
              </div>

              {/* LinkedIn */}
              <div className="contact-item" style={{
                textAlign: 'center',
                padding: '30px',
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                borderRadius: '10px',
                minWidth: '280px',
                transition: 'transform 0.3s ease'
              }}>
                <i className="fa fa-linkedin" style={{ fontSize: '48px', marginBottom: '15px', color: '#11ABB0' }}></i>
                <h4 style={{ marginBottom: '10px', color: '#EBEEEE' }}>LinkedIn</h4>
                <a 
                  href={resumeData.linkedinId} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  style={{ 
                    color: '#fff', 
                    fontSize: '16px',
                    textDecoration: 'none'
                  }}
                >
                  Omar Ghamrawi
                </a>
              </div>

              {/* Location */}
              <div className="contact-item" style={{
                textAlign: 'center',
                padding: '30px',
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                borderRadius: '10px',
                minWidth: '280px',
                transition: 'transform 0.3s ease'
              }}>
                <i className="fa fa-map-marker" style={{ fontSize: '48px', marginBottom: '15px', color: '#11ABB0' }}></i>
                <h4 style={{ marginBottom: '10px', color: '#EBEEEE' }}>Location</h4>
                <p style={{ color: '#fff', fontSize: '16px', margin: 0 }}>
                  {resumeData.address}
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Social Links */}
        {/* <div className="row" style={{ marginTop: '50px' }}>
          <div className="twelve columns">
            <ul className="social-links" style={{
              textAlign: 'center',
              listStyle: 'none',
              padding: 0,
              margin: 0
            }}>
              {resumeData.socialLinks && resumeData.socialLinks.map((item, index) => (
                <li key={index} style={{ display: 'inline-block', margin: '0 15px' }}>
                  <a href={item.url} target="_blank" rel="noopener noreferrer">
                    <i className={item.className} style={{ fontSize: '36px' }}></i>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div> */}
      </section>
    );
  }
}